module.exports = __webpack_public_path__ + "static/media/card-primary.3f053d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-primary.png
// module id = 615
// module chunks = 0